import { IconSVG } from '../types';

export const Pause = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        d="M16.429 20a2.201 2.201 0 01-1.615-.671 2.201 2.201 0 01-.671-1.615V6.286c0-.629.224-1.167.671-1.615A2.2 2.2 0 0116.43 4c.628 0 1.166.224 1.614.671.448.448.671.986.671 1.615v11.428c0 .629-.223 1.167-.671 1.615a2.201 2.201 0 01-1.614.671zm-9.143 0a2.201 2.201 0 01-1.615-.671A2.2 2.2 0 015 17.714V6.286c0-.629.224-1.167.671-1.615A2.201 2.201 0 017.286 4c.628 0 1.166.224 1.614.671.448.448.671.986.671 1.615v11.428A2.2 2.2 0 018.9 19.33 2.201 2.201 0 017.286 20z"
      />
    </svg>
  );
};
